import { useFarmListQuery } from './useFarmListQuery';
export const useFarmId = (options) => {
    var _a;
    const { data: farms } = useFarmListQuery(options);
    return (_a = farms === null || farms === void 0 ? void 0 : farms.find(({ sharedAccess }) => !sharedAccess)) === null || _a === void 0 ? void 0 : _a.id;
};
//# sourceMappingURL=useFarmId.js.map